<template>
  <div class="w-full">
    <el-card class="m-6" shadow="none">
      <div slot="header" class="clearfix">
        <span class="leading-loose">{{ cardTitle }}</span>
        <div class="float-right pl-2">
          <el-button
            type="primary"
            size="medium"
            icon="el-icon-plus"
            @click="handleAdd()"
            >Toevoegen</el-button
          >
        </div>
        <el-button
          v-if="this.$store.getters.isAdmin"
          type="info"
          size="medium"
          class="float-right"
          icon="el-icon-folder"
          @click="createExport()"
          >Export</el-button
        >
      </div>

      <el-table
        :data="tableData"
        class="w-full"
        row-key="id"
        @sort-change="sort"
        :default-sort="{ prop: 'firstName', order: 'ascending' }"
      >
          
        <el-table-column
          sortable="custom"
          prop="enrollment.firstName"
          label="Voornaam"
          width="240"
        >
        </el-table-column>

        <el-table-column
          sortable="custom"
          prop="enrollment.lastName"
          label="Achternaam"
          width="240"
        >
        </el-table-column>

        <el-table-column
          sortable="custom"
          prop="enrollment.birthDate"
          label="Geboortedatum"
        >
          <template slot-scope="scope">
            {{ moment(scope.row.enrollment.birthDate).format("DD-MM-YYYY") }}
          </template>
        </el-table-column>

        <el-table-column label="Operaties">
          <template slot-scope="scope">
            <el-button size="mini" @click="handleEdit(scope.$index, scope.row)"
              >Wijzigen</el-button
            >
            <el-button
              size="mini"
              type="danger"
              @click="handleDelete(scope.$index, scope.row)"
              >Verwijderen</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    

      <el-pagination
        class="mt-6"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="currentPage"
        :page-sizes="pageSizes"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalElements"
      >
      </el-pagination>
    </el-card>

    <user-dialog
      ref="addEditDialog"
      :branch-options="branchOptions"
    ></user-dialog>
  </div>
</template>

<script>
import UserDialog from "./dialogs/UserDialog";

export default {
  name: "Users",
  components: {
    UserDialog
  },
  data() {
    return {
      // Title
      cardTitle: "Gebruikers",
      itemName: "gebruiker",
      branchOptions: this.getBranchOptions(),

      // Table data
      tableData: this.getList(),
      numPages: 1,
      pageSize: 10,
      currentPage: 1,
      pageSizes: [10, 20, 50],
      totalElements: 0
    };
  },
  methods: {
    handleSizeChange() {
      this.getList();
    },
    handleCurrentChange() {
      this.getList();
    },
    handleDelete(index, obj) {
      this.$confirm(
        `Het verwijderen van een ${this.itemName} is een actie die niet ongedaan kan worden gemaakt. Bent u zeker dat u ${obj.enrollment.firstName} wil verwijderen?`,
        `${this.capitalize(this.itemName)} verwijderen`,
        {
          confirmButtonText: "Verwijderen",
          cancelButtonText: "Annuleer",
          customClass: "p-4"
        }
      ).then(() => {
        this.$http
          .delete(`admin/users/${obj.id}`)
          .then(response => {
            this.$notify({
              title: `${this.capitalize(this.itemName)} verwijderd`,
              message: `${this.capitalize(
                this.itemName
              )} werd successvol verwijderd.`,
              type: "success"
            });
            this.getList();
          })
          .catch(error => {
            this.$message({
              showClose: true,
              message: `Kon ${this.itemName} niet verwijderen`,
              type: "error"
            });
            console.log(error);
          });
      });
    },
    handleEdit(index, row) {
      this.$refs.addEditDialog.edit(row);
    },
    handleAdd() {
      this.$refs.addEditDialog.add();
    },
    objAdded(obj) {
      // Add API call here
      this.$http
        .post("admin/users", obj)
        .then(response => {
          this.$notify({
            title: `${this.capitalize(this.itemName)} toegevoegd`,
            message: `${this.capitalize(this.itemName)} ${
              obj.enrollment.firstName
            } ${obj.enrollment.lastName} werd successvol toevoegd.`,
            type: "success"
          });
          this.$refs.addEditDialog.close();
          this.getList();
        })
        .catch(error => {
          this.$refs.addEditDialog.openAlert(
            `Kon ${this.itemName} niet toevoegen`,
            "error"
          );
          console.log(error);
        });
    },
    objEdited(obj) {
      // Add API call here
      this.$http
        .put(`admin/users/${obj.id}`, obj)
        .then(response => {
          this.$notify({
            title: `${this.capitalize(this.itemName)} gewijzigd`,
            message: `${this.capitalize(this.itemName)} ${
              obj.enrollment.firstName
            } ${obj.enrollment.lastName} werd successvol gewijzigd.`,
            type: "success"
          });
          this.$refs.addEditDialog.close();
          this.getList();
        })
        .catch(error => {
          this.$refs.addEditDialog.openAlert(
            `Kon ${this.itemName} niet wijzingen`,
            "error"
          );
          console.log(error);
        });
    },
    sort(props) {
      if (props.order === "ascending") {
        this.sortDir = "ASC";
      } else {
        this.sortDir = "DESC";
      }
      this.sortBy = props.prop;
      this.getList();
    },
    getBranchOptions() {
      const that = this;
      this.$http
        .get("admin/branches/list")
        .then(response => {
          this.branchOptions = response.data;
        })
        .catch(function(error) {
          if (error.response.status === 403) {
            that.$router.replace({ name: "Login", force: true });
          }
          this.branchOptions = [];
          console.log(error);
        });
    },
    getList() {
      let params = {};
      const that = this;
      params["numPerPage"] = this.pageSize;
      params["page"] = this.currentPage;
      if (this.sortDir != null && this.sortBy != null) {
        params["sortBy"] = this.sortBy;
        params["sortDir"] = this.sortDir;
      }

      this.$http
        .get("admin/users", {
          params: params
        })
        .then(response => {
          const listResponse = response.data.content;
          this.tableData = listResponse;
          this.totalElements = response.data.totalElements;
        })
        .catch(function(error) {
          if (error.response.status === 403) {
            that.$router.replace({ name: "Login", force: true });
          }
          console.log(error);
        });
    },
    createExport() {
      const that = this;
      this.loading = true;
      this.$http({
        method: "post",
        url: `admin/users/export`,
        responseType: "arraybuffer",
        data: {
          firstName: "dummy"
        }
      })
        .then(function(response) {
          that.loading = false;
          that.exportDone = true;
          let blob = new Blob([response.data], {
            type:
              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          });
          let link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = "gebruikers.xlsx";
          link.click();
          that.$notify({
            title: `Export sucessvol!`,
            message: `Inschrijvingslijst werd succesvol geëxporteerd, het bestand is terug te vinden in de downloads.`,
            type: "success"
          });
        })
        .catch(function(error) {
          that.$message({
            showClose: true,
            message: "Oops! Er ging iets mis, probeer later opnieuw.",
            type: "error"
          });
          console.log(error);
        });
    },
    capitalize(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    }
  }
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/dashboard/users/Users.vue